import { openDB } from 'idb';
import { SWPData } from '../models/swp';

const dbPromise = openDB('swp-db', 1, {
  upgrade(db) {
    db.createObjectStore('swps', { keyPath: 'id', autoIncrement: true });
  },
});

export const saveSWP = async (swp: SWPData): Promise<void> => {
  const db = await dbPromise;
  try {
    await db.add('swps', swp);
  } catch (error) {
    console.error('Error saving swp:', error);
    throw new Error('Could not save swp.');
  }
};

export const fetchSWP = async (): Promise<SWPData[]> => {
  const db = await dbPromise;
  try {
    return await db.getAll('swps');
  } catch (error) {
    console.error('Error fetching swp:', error);
    throw new Error('Could not fetch swps.');
  }
};

export const updateSWP = async (id: number, updatedData: Omit<SWPData, 'id'>): Promise<void> => {
  const db = await dbPromise;
  await db.put('swps', { id, ...updatedData });
};


export const deleteSWP = async (id: number): Promise<void> => {
  const db = await dbPromise;
  try {
    await db.delete('swps', id);
  } catch (error) {
    console.error('Error deleting swp:', error);
    throw new Error('Could not delete swp.');
  }
};
